<template>
	<div class="ReCardKBPost" v-if="this.objFAQ">

		<!-- <collapse :activeIndex="1">
			<collapse-item :title="objFAQ.name" :name="'faq_'+objFAQ.id">
				<p v-html="objFAQ.descr">
					{{objFAQ.descr}}
				</p>
			</collapse-item>
		</collapse>   -->

		<div class="d-flex">
			<router-link :to="'/data/knowledgebase/posts/'+kb_group+'/id/'+objFAQ.id">{{objFAQ.name}}</router-link>
			<!-- <ReCopyClipboard v-model="location.origin+'/data/ticketsystem/faq/id/'+objFAQ.id" v-if="this.$GVO.my_profile.Support == 1 || this.$GVO.my_profile.adm == 1"/> -->
		</div>
		
	</div>
</template>

<script>
// import { Collapse, CollapseItem } from 'src/components';
// import ReCopyClipboard from 'src/our_components/ReCopyClipboard.vue';

export default {
	name: "ReCardKBPost",
	components: {
		// Collapse,
		// CollapseItem,
		// ReCopyClipboard,
	},
	props: {
		objFAQ: Object,
		kb_group:{
			type: String,
			default: 'KB_MAIN',
		}
	},
	data() {
		return {
			ver: 1
		};
	},
	computed: {},
	methods: {
		
	},
	mounted() {
		//console.log(location.origin);
	}
};
</script>

<style scoped>
.ReCardKBPost >>> .photoFAQ, .TicketSystemFaqItem >>> .photoFAQ{
	max-width: 600px;
    height: auto;
    margin: 10px 0;
    width: 100%;
}
.ReCardKBPost p {max-width: 600px;}
.ReCardKBPost {
	display: flex;
	flex-direction: column;
	margin-bottom: 5px;
	/* max-width: 49%; */
}
.ReCardKBPost .card-collapse{
	border-right: none!important;
	height: fit-content;
	display: inline-block;
	width: 100%!important;
	padding: 0px;
}
.ReCardKBPost >>> .card-collapse .card:not(.card-cinc) .card-header a {color: #01B0E0;}


</style>
